<div class="mrs-table-inner-container" style="background-color: white; padding: 16px; gap: 8px;">
    <div class="d-flex align-items-center" style="gap: 8px;">
        <h2 style="margin: 0;">Assigned Cases</h2>
        <mat-chip *ngIf="activeFilterCount > 0" disabled class="filter-count-badge">{{ activeFilterCount }} Filter{{ activeFilterCount === 1 ? '' : 's' }} Active</mat-chip>
    </div>
    <div class="table-scroll-wrapper" [class.without-side-nav]="isSideNavHidden">
        <table #dataTable mat-table matSort [dataSource]="dataSource" class="mat-elevation-z1 assigned-cases-table">
            <ng-container matColumnDef="selection" sticky>
                <th mat-header-cell *matHeaderCellDef style="width:55px" id="selectionHeader">
                </th>
                <td mat-cell *matCellDef="let element" (click)="stopPropagation($event)">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)"></mat-checkbox>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="account">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
                <td mat-cell *matCellDef="let element">
                    <span [matTooltip]="element.account">{{ element.account }}</span>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="caseDisplayNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Case #</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.caseDisplayNumber }}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="policyNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Policy #</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.policyNumber }}
                </td>
            </ng-container>

            <ng-container matColumnDef="assignedTo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.assignedTo }}
                </td>
            </ng-container>

            <ng-container matColumnDef="faceAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Face Amount</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.faceAmount | currency:'USD':'symbol':'1.0-0' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="queue">
                <th mat-header-cell *matHeaderCellDef>Queue</th>
                <td mat-cell *matCellDef="let element">
                    <span
                        *ngFor="let queueItem of element.queue"
                        class="tag"
                        [class]="getChipColor(queueItem.dueDate)"
                        matTooltipClass="queue-item-tooltip"
                        matTooltipPosition="above"
                        [matTooltip]="queueItem.dueDate ? queueItem.queueName + '\n' + (queueItem.dueDate | date: 'MMMM d, y, h:mm a') : ''"
                    >
                        <span class="queue-name">{{ queueItem.queueName }}</span>
                        <ng-container *ngIf="isPastDue(queueItem.dueDate)">
                            &nbsp;(Past Due)
                        </ng-container>
                        <ng-container *ngIf="!isPastDue(queueItem.dueDate) && getRemainingHours(queueItem.dueDate, queueItem.useBusinessHours) as remainingHours; else noHours">
                            &nbsp;({{ remainingHours }}
                            {{ remainingHours === 1 ? 'hour' : 'hours' }})
                        </ng-container>
                        <ng-template #noHours></ng-template>
                    </span> 
                </td>
            </ng-container>

            <ng-container matColumnDef="requirementsReceived">
                <th mat-header-cell *matHeaderCellDef>Requirements Received</th>
                <td mat-cell *matCellDef="let element">
                    <ul class="requirements-list">
                        <li *ngFor="let requirement of element.requirementsReceived">{{ requirement }}</li>
                    </ul>
                </td>
            </ng-container>

            <ng-container matColumnDef="openTasks">
                <th mat-header-cell *matHeaderCellDef>Open Tasks</th>
                <td mat-cell *matCellDef="let element">
                    <span
                        *ngIf="element.openTasks?.length > 0"
                        [matTooltip]="getOpenTasksTooltip(element.openTasks)"
                        matTooltipClass="multiline-tooltip"
                        matTooltipPosition="above"
                        (click)="stopPropagation($event)"
                        style="cursor: default;"
                    >
                        {{ element.openTasks.length }} open
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div *ngIf="dataSource.filteredData == null || dataSource.filteredData.length == 0" class="bg-white">
            <div class="p-4 text-center text-muted ">
                <img src="./assets/images/no-data-placeholder.png " alt=" " class="pb-3 " />
                <h6>No Cases Found</h6>
            </div>
        </div>
    </div>
    <div class="flex align-items-center">
        <div id="actionButtons" *ngIf="selection.selected.length > 0" class="flex align-items-center">
            <mat-chip-set>
                <mat-chip>{{selection.selected.length}} selected</mat-chip>
            </mat-chip-set>
            <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Assign To</mat-label>
                <mat-select [value]="bulkAssignUserId" (selectionChange)="onBulkAssignTo($event.value)">
                    <mat-option *ngFor="let user of assignableTeamUsers" [value]="user.id">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <div style="display: flex; flex-direction: column; line-height: 1.3; gap: 2px;">
                                <span>{{ user.userName }}</span>
                                <span style="font-size: 12px;">{{ userCaseCounts[user.id] || 0 }} total assigned case{{ userCaseCounts[user.id] === 1 ? '' : 's' }}</span>
                            </div>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div style="margin-left: auto">
            <mat-paginator
                #paginator
                *ngIf="dataSource?.data?.length > 0"
                [length]="dataSource?.data?.length || 0"
                [pageIndex]="0"
                [pageSize]="10"
                appearance="fill"
                [pageSizeOptions]="[10, 25, 50, 100]"
            >
            </mat-paginator>
        </div>
    </div>
</div>